import { all, takeLatest } from "redux-saga/effects";
import { types as modalsAnchorActions } from "@gc-npm/reducers.modals-reducer";
import { types as headerActions } from "@gc-npm/reducers.header-reducer";
import { types as mainActions } from "@gc-npm/reducers.main-reducer";
import {
  initAnchorModalListener,
  addModal,
} from "@gc-npm/sagas.modals-saga";
import {
  checkCPAndSetZones,
  setReadNotificationsSaga,
} from "@gc-npm/sagas.main-saga";
import { types as clientPersonalizationTypes } from "@/reducers/client-personalization";
import {
  initClientPersonalizationLM,
  updateClientPersonalizationLM,
} from "./client-personalization";
function* rootSaga() {
  yield all([
    takeLatest(
      modalsAnchorActions.INIT_ANCHOR_MODAL_LISTENER,
      initAnchorModalListener
    ),
    takeLatest(modalsAnchorActions.ADD_MODAL, addModal),
    // cp
    takeLatest(mainActions.CHECK_CP_AND_SET_ZONES, checkCPAndSetZones),
    takeLatest(
      clientPersonalizationTypes.INIT_PERSONALIZATION,
      initClientPersonalizationLM
    ),
    takeLatest(
      clientPersonalizationTypes.UPDATE_PERSONALIZATION,
      updateClientPersonalizationLM
    ),
    takeLatest(
      mainActions.SET_READ_NOTIFICATIONS_INIT,
      setReadNotificationsSaga
    ),
  ]);
}

export default rootSaga;
